import { render } from "./SocialAuthButtons.vue?vue&type=template&id=4f02ab7f"
import script from "./SocialAuthButtons.vue?vue&type=script&lang=js"
export * from "./SocialAuthButtons.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__